import styled from "styled-components";

import color from "../../constants/color";
import materialUI from "../../material-UI";

export const FormTag = styled(materialUI.ToggleButtonGroup)`
  width: 100%;
  flex-wrap: wrap;
  gap: 6px;
`;

export const LabelTag: any = styled(materialUI.ToggleButton)`
  height: 24px;
  min-width: 35px;
  background: ${(props: any) => props.background} !important;
  border-radius: 8px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px !important;
  line-height: 16px !important;
  letter-spacing: -0.01em;
  color: white !important;
  text-transform: capitalize !important;
  padding: 0 8px !important;
  margin-right: 6px !important;
  margin-bottom: 6px !important;
  border: none !important;
  transition: all 0.2s;

  &.Mui-selected {
    position: relative;
    color: ${color.White}!important;
    opacity: 0.7 !important;
    border: none !important;
    outline: none !important;

    &::after {
      content: "";
      position: absolute;
      top: -4px;
      bottom: -4px;
      left: -4px;
      right: -4px;
      border: 2px solid #c0c0c0;
      border-radius: 12px;
      pointer-events: none;
    }
  }
`;
